<template>
  <template v-if="$page && $beet.isReady">
    <section class="section -less-pad -center" v-if="$page">
      <h1 class="section__header" v-reveal>{{ $page.header.title }}</h1>
      <p class="section__text" v-reveal="{ delay: 225 }">{{ $page.header.description }}</p>
    </section>

    <PageBuilder :sections="$page.sections" v-if="$page" />
  </template>

  <template v-else>
    <Loader />
  </template>
</template>

<script>
import Loader from '@/App.vue'
import PageBuilder from '@/components/PageBuilder.vue'
import { setMeta } from '@/helpers/metaHelpers'

export default {
  name: 'About',
  components: { Loader, PageBuilder },
  beetPage: 'about',
  watch: {
    $page(to) {
      setMeta(to.seo)
    },
  },
  beforeMount() {
    if (this.$page) setMeta(this.$page.seo)
  },
}
</script>
